import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { EntityKpi } from '@components/EntityKpi'
import { MyListButton } from '@components/MyListButton'
import { formatDateTime } from '@util/date-util'

import {
  type Subproces,
  SubprocesTypes,
} from '../../../entity/subprocessen/types/Subproces'
import { getStatusLabelForType } from '../../../entity/subprocessen/util/subproces-util'
import { Due } from '../../../theme/components/Due'
import { Label } from '../../../theme/components/Label'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

const getEntityLabel = (type: string, projecttype?: string) => {
  return (
    projecttype ||
    {
      project: 'Project',
      projectdossier: 'Projectdossier',
    }[type]
  )
}

interface Props {
  subproces: Subproces
}

export const SubprocessenTableRow = ({ subproces }: Props) => {
  const {
    _id,
    type,
    status,
    assignedTo,
    dueDate,
    entity: { id: entityId, type: entityType, projecttype, gebiedscodeLabel },
    searchValues,
    myList,
    labels,
  } = subproces
  const { organisatie, date: created } = subproces.created

  return (
    <TableRow key={_id}>
      <TableCell>
        <EntityKpi kpi={subproces.kpi} />
      </TableCell>
      <TableCell>
        {SubprocesTypes[type]}
        <Typography
          variant="caption"
          sx={{
            display: 'block',
          }}
        >
          {getStatusLabelForType(type, status)}
        </Typography>
      </TableCell>
      <TableCell>
        <Due dueDate={dueDate} />
      </TableCell>
      <TableCell>{formatDateTime(created)}</TableCell>
      <TableCell>{organisatie}</TableCell>
      <TableCell>{assignedTo}</TableCell>
      <TableCell>
        {getEntityLabel(entityType, projecttype)} <span>{entityId}</span>
      </TableCell>
      <TableCell>{searchValues.adres}</TableCell>
      <TableCell>
        {gebiedscodeLabel}
        <br />
        {labels && labels.map((l) => <Label text={l} key={l} small={true} />)}
      </TableCell>
      <TableCell>
        <MyListButton
          type="aansluiting"
          disabled={true}
          active={myList}
          aanvraagID={''}
        />
        <StyledIconLink
          icon={<LaunchIcon />}
          title={`Navigeer naar ${entityType} ${entityId}`}
          href={`/aansluiting/${entityType}/${entityId}`}
        />
      </TableCell>
    </TableRow>
  )
}
